import { forwardRef, HTMLAttributes } from "react";
import Image from "next/image";

import { cn } from "src/utils/cn";

export enum SocialPlatforms {
  FACEBOOK = "Facebook",
  APPLE = "Apple",
}

export type SocialLoginButtonProps = HTMLAttributes<HTMLButtonElement> & {
  platform: SocialPlatforms;
  authType: "Login" | "Sign up";
  width?: SocialLoginButtonWidth;
};

export type SocialLoginButtonWidth = "default" | "full";

const socialLoginButtonSizeStyles: Record<SocialLoginButtonWidth, string> = {
  default: `w-[280px]`,
  full: `w-full`,
};

const socialLoginButtonStyles: Record<string, string> = {
  default: `relative border border-solid border-gray-200 rounded-lg p-2.5 px-8 font-medium text-center text-gray-700 text-xs cursor-pointer mx-auto bg-no-repeat active:scale-[.98] transition-colors transition-transform`,
};

export const SocialLoginButton = forwardRef<
  HTMLButtonElement,
  SocialLoginButtonProps
>(function SocialLoginButton(
  { platform, authType, width = "default", ...props },
  ref
) {
  const icon =
    platform === SocialPlatforms.FACEBOOK
      ? ({
          src: "/images/icons/icnFacebook.svg",
          width: 20,
          height: 20,
          alt: "",
        } as const)
      : ({
          src: "/images/icons/icnApple.svg",
          width: 20,
          height: 20,
          alt: "",
        } as const);

  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        socialLoginButtonStyles.default,
        socialLoginButtonSizeStyles[width],
        platform === SocialPlatforms.FACEBOOK
          ? `hover:border-[#0075FB]`
          : `hover:border-[#434343]`
      )}
      {...props}
    >
      <Image {...icon} className="absolute top-1/2 left-5 -mt-2.5 h-5 w-5" />
      {`${authType} with ${platform}`}
    </button>
  );
});
